import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';

const styles = {
    icon: {overflow: 'inherit'},
};

const ViewButtonByLocationTransferId = ({basePath = '', record = {}}) => {
    let path = `${record.transfer_type}/${record.location_to}/${record.transfer_id}`;
    if (record.transfer_type === 'memo') {
        path = `${record.transfer_type}/${record.transfer_id}`;
    }
    return (
        <IconButton
            containerElement={<Link
                to={`${basePath}/${path}/show`}
            />}
            style={styles.icon}
        >
            <ContentView color={FuseTheme.palette.primary1Color}/>
        </IconButton>
    )
};

ViewButtonByLocationTransferId.propTypes = {
    basePath: PropTypes.string,
    onClickFunc: PropTypes.func,
    record: PropTypes.object,
};

ViewButtonByLocationTransferId.defaultProps = {
    basePath: '',
    record: {},
    style: {padding: 0},
};

export default ViewButtonByLocationTransferId;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/ViewButtonByLocationTransferId.js